export default {
  env: 'production',
  apiBaseURL: 'https://api.linkiafp.es/api',
};
